import $ from "jquery";
import hash from "./hash";
const defaultHash = "#universe";
import Store    from "./Store";
// import { ModalHelper } from "./B2bTools";
// import { cgvModalHtml } from "./formulaire/cgvModal.html";
// import { cgvModalJs } from "./formulaire/cgvModal.js";
// import { createApp } from "vue";
// import MiniFormulaire from "./MiniFormulaire";





class Contexte {
	constructor(session) {
		this.session = session;
		this.orderManager = null;

		this.univer = null;
		this.univerV = null;
		this.univerList = [];

		this.cliqueSurUniver = false;

		this.notifications = null;
		this.tasks = null;
		this.sidebar = null;
		this.topbar = null;

		this.disableOnHashChange = false;
		this.defaultHash = null;

		this.key = null;
		this.acceptedCGU = false; 

	}
	async setUniver(u) { 

		let a = this.univerList.find((x) => x.k == u); 
		if (a) {
			this.univer = a.k;
			this.univerV = a.v;

			const univerTitle = document.querySelector("#univer-title");
			univerTitle.innerHTML = this.univerV;
			if (!this.orderManager) {
				await this.updatepanier(this.univer);
			} 
			await this.updateTaskFormulaire(); 
			if (this.sidebar) this.sidebar.externalfunc(a); 
		}
 
		// if(!this.acceptedCGU)   this.cgvModal()  

	}
	getUniverV() {
		return this.univerV;
	}
	hasUniver(u) {
		return this.univerList.includes(u);
	} 
	getURUL(u) {
		let p = hash.toArray()[0].par.u;
		return p;
	}
	getKey(){
		let displayname = (this.session && this.session.displayname)? this.session.displayname : "displayname";
		return  `${this.univer}~${ displayname}`;
	}
	dirtyKey(){
		const dirty =  (!this.key || this.getKey()!=this.key)
		return dirty;
	}
	updateKeys() {
        this.key = this.getKey();
    }
	
	async update(p,force) { 
		if (force===true || !this.orderManager || this.dirtyKey() ) {
			this.updateKeys();
			await this.updatepanier(p);
			await this.updateTaskFormulaire(p);
		} 
		await this.afficheSidebar(p);
		await this.refreshUniver(p);
	}
	afficheSidebar() {
		
		const array = hash.toArray();
		const hash0 = array.length ? array[0] : {};

		if ("#" + hash0.hash !== defaultHash) {
			$("#topbar").removeClass("d-none");
			$("#sidebar").removeClass("d-none");
			$("#univer-title").removeClass("d-none");
		} else {
			$("#topbar").addClass("d-none");
			$("#sidebar").addClass("d-none");
			$("#univer-title").addClass("d-none");
		}
	}


	async logErrors(errors) {
		console.log(errors);
		$(".___error").removeClass("d-none");
	}
 
	async refreshUniver(mf) {
		const u = this.getURUL();
		const univerTitle = document.querySelector("#univer-title").getAttribute("innerHTML");
			
		// if(this.cgvModal) this.modalCGU(); 

		if (u && (u != this.univer || !this.univerV)){
			this.setUniver(u);
		} 
		if(u && (univerTitle=="" || univerTitle=="undefined") ){
			this.setUniver(u); 
		}  
 


		// Augustin 24/02/2024
		// console.log("🦆 🐟 🐬 🦇 🐍"); 

		// Florian 27/02/2024
		// console.log("🐔 🍆 🐵 🐼 🍪 🍟 ⚰️ 🏋️‍♂️ 🐧 ✈️");
		
		// Augustin 03/08/2024
		// console.log("🐼 ✈️ ✈️ "); 

		// Martin 31/04/2025
		// console.log("⚰️"); 
	}
}

export default Contexte;

// async function updateTaskFormulaire() {
// 	CTX.tasks = null;
// 	{
// 		CTX.tasks = new MiniFormulaire("tasks");
// 		CTX.tasks.initialise("#asidetasksbadgealert");
// 		CTX.tasks.fillImport(formulaire.tasks);
// 		CTX.tasks.CTX = CTX;
// 		await CTX.tasks.demarre(CTX.session);
// 	}
// }

// const univerTitle = document.querySelector("#univer-title");
// 		const uu   = this.getURUL();
// 		return this.univerList.find( (u) => u.k === uu )?.v;

// 		// univerTitle.innerHTML = univerV;

// const CTX = {
// 	session: null,
// 	orderManager: null,
// 	univer: null,
// 	univerV: null,
// 	univerList: [],
// 	cliqueSurUniver: false,
// 	notifications: null,
// 	tasks: null,
// 	sidebar: null,
// 	topbar: null,
// 	disableOnHashChange: false,
// 	getURUL(u) {
// 	  return hash.toArray()[0].par.u;
// 	},
// 	update(){
// 	  this.updateTaskFormulaire();
// 	  this.updatepanier();
// 	}
//  };

// 	hasUniver(hash0){
// 		return (this.univer!=null && !this.univer.includes(hash0.par.u))
// 	  },
// 	  afficheSidebar(){
// 		if ("#" + hash0.hash !== defaultHash) {
// 		  $("#sidebar").removeClass("d-none");
// 		  $("#univer-title").removeClass("d-none");
// 		} else {
// 		  $("#sidebar").addClass("d-none");
// 		  $("#univer-title").addClass("d-none");
// 		}
// 	},
